
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import SwitchStatus from "@common/src/components/scope/switch-status/index.vue";
import StandardFlag from "@common/src/components/scope/standard-flag/index.vue";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
const testingItem = namespace("testing-item");
const base = namespace("base");
@InjectFunction("emptyToLine", "appCode", "permitApp")
@Component({
  components: { SwitchStatus, StandardFlag }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("setting.select-test-item"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table",
  checkableFuncName: "checkable"
})
export default class TestingItemList extends Vue {
  @testingItem.Action getTestingItemList;
  @testingItem.Action updateItemsStatus;
  @testingItem.Action syncTestItem;
  @base.Action getDictionaryList;

  searchForm = {
    checkItemName: "",
    checkItemNo: "",
    source: ""
  };
  testItemList: any[] = [];
  get searchList() {
    return [
      {
        label: "test.test-teme-search1",
        type: "input",
        value: "",
        prop: "checkItemName"
      },
      {
        label: "test.test-teme-search2",
        type: "input",
        value: "",
        prop: "checkItemNo"
      },
      ...(this.appCode === "speedbiz"
        ? [
            {
              label: "base.from-source",
              type: "select",
              value: "",
              selectList: this.testItemSourceList,
              prop: "source"
            }
          ]
        : [])
    ];
  }
  testItemSourceList: any = [];
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  @TableRowsSelect.updateMethod
  confirmUpdateStatus(status, selectedRow) {
    return this.updateItemsStatus({
      status: status,
      checkItemCodeArray: selectedRow
        ? [selectedRow.checkItemCode]
        : this.mix_selectedRows.map(item => item.checkItemCode)
    }).then(() => {
      this.$message.success(status ? t("setting.enable-successful") : t("setting.disable-success"));
      this.loadListData();
    });
  }
  created() {
    this.init();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getTestingItemList({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      status: "9"
    }).then(data => {
      this.testItemList = data.data.list;
      return data;
    });
  }
  async init() {
    this.loadListData();
    this.getDictionaryList("check_source").then(data => {
      this.testItemSourceList = data;
    });
  }
  handleEdit(row) {
    this.$router.push(`/setting/test-items-edit/${row.checkItemCode}`);
  }
  handleView(row) {
    this.$router.push(`/setting/test-items-view/${row.checkItemCode}`);
  }
  checkable(row) {
    if (this.permitApp("speedbiz-operation")) {
      return true;
    }
    return row.source === "2";
  }
  handleSync(row) {
    this.syncTestItem({
      checkItemCode: row.checkItemCode
    }).then(() => {
      this.$message.success(t("v213.detection-items-have-been-synchronized-to-the-store"));
      this.loadListData();
    });
  }
}
